import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { getAuth, signInWithEmailAndPassword } from '@angular/fire/auth';;
import { IUser } from 'src/app/model/user';
import { LoginService } from 'src/app/services/login/login.service';
import { RegistrationService } from 'src/app/services/registration/registration.service';
import { EmailServiceComponent } from 'src/app/services/mail/email.service';
import { Countries } from '../../common/country/countries';
import { PhoneValidatorProvider } from '../../common/country/phone-validator';
import { SettingService } from 'src/app/services/setting/setting-service';
import * as moment from 'moment';

@Component({
  selector: 'app-profile-authentication',
  templateUrl: './profile-authentication.component.html',
  styleUrls: ['./profile-authentication.component.scss']
})
export class ProfileAuthenticationComponent implements OnInit {

  firstname;
  submitted = false;
  disableRegistration = false;
  showSpinner;
  obligation = "Obligation envers quelqu'un ou un groupe";
  errorMessage = "Veuillez remplir les champs en rouge.";
  hasError;
  countries;
  message;
  loginForm: FormGroup = new FormGroup({
    email: new FormControl(
      '',
      [
        Validators.required,
        Validators.email,
      ]),
    password: new FormControl(
      '',
      [
        Validators.required,
      ]),

    level: new FormControl(
      '1',
      [
        Validators.required,
      ]),

    remember: new FormControl(
      ''),
  });

  registrationForm;

  public currentStep: 1 | 2 | 3 = 1;

  public submitSteps = { step1: false, step2: false, step3: false };

  constructor(public setting: SettingService, private emailService: EmailServiceComponent,
    private registrationService: RegistrationService,
    public formBuilder: FormBuilder,
    private listCountries: Countries,
    private loginService: LoginService) { }

  ngOnInit(): void {

    this.setting.settingRegistration().subscribe(x => {
      this.disableRegistration = x[0].disabled;
    })
    this.countries = this.listCountries.getCountries();
    let i = 0;

    let country = new FormControl(this.countries[72], Validators.required);
    let phone = ['', {
      validators: [PhoneValidatorProvider.validCountryPhone(country)]
    }];

    console.log(country.value.code);

    this.registrationForm = new FormGroup({

      step1: this.formBuilder.group({

        email: new FormControl(
          '',
          [
            Validators.required,
            Validators.email,
          ]),
        name: new FormControl(
          '',
          [
            Validators.required,
          ]),

        firstname: new FormControl(
          '',
          [
            Validators.required,
          ])
      }),

      step2: this.formBuilder.group({
        phone: phone,
        country: country

      }),

      step3: this.formBuilder.group({
        reason: new FormControl(
          'Aucune, juste par curiosité',
          [
            Validators.required,
          ]),
          level: new FormControl(
            '1',
            [
              Validators.required,
            ])
      }),
    });


  }

  /**
   * Check if the form in a specific step of validation is valid
   * 
   * @returns  true or false
   */
  public isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 1:
        this.submitSteps.step1 = true;
        this.submitSteps.step2 = false;
        this.submitSteps.step3 = false;
        return this.registrationForm.get('step1').valid;
      case 2:
        this.submitSteps.step2 = true;
        this.submitSteps.step1 = false;
        this.submitSteps.step3 = false;
        return this.registrationForm.get('step2').valid && this.registrationForm.get('step2').value.phone.length != 0;
      case 3:
        this.submitSteps.step3 = true;
        this.submitSteps.step2 = false;
        this.submitSteps.step1 = false;
        return this.registrationForm.get('step3').valid;
      default:
        return true; // Si l'étape n'est pas définie, retourne true
    }
  }

  public next(): void {
    if (this.isCurrentStepValid()) {
      if (this.currentStep == 1) {
        this.currentStep = 2;
      }
      else if (this.currentStep == 2) {
        this.currentStep = 3;
      }
    }
    this.message ="";
    this.errorMessage="";
  }

  public previous(): void {
    if (this.currentStep == 2) {
      this.currentStep = 1;
      this.submitSteps.step1 = false;
    }
    else if (this.currentStep == 3) {
      this.currentStep = 2;
      this.submitSteps.step2 = false;
    }
  }

  /**
   * 
   * 
   */
  onSubmitRegistration() {

    this.submitted = true;
    this.hasError = false;
    this.showSpinner = false;


    let phone_format = this.registrationForm.get("step2").value.phone.replace(/ /g, '')
      .replace(/(_)/g, '').replace(/(-)/g, '');
    phone_format = phone_format.indexOf('0') != 0 ? '0' + phone_format : phone_format;
    let user = {
      date: moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
      email: this.registrationForm.get("step1").value.email,
      firstname: this.registrationForm.get("step1").value.firstname,
      name: this.registrationForm.get("step1").value.name,
      country: this.registrationForm.get("step2").value.country.name,
      phone: phone_format,
      promotion: (new Date()).getFullYear(),
      inscriptionConfirmed:false,
      reason: this.registrationForm.get("step3").value.reason
    }

    console.log(user);

    this.registrationService.preRegistration(user)
      .subscribe({
        next: (value) => {
          if (value) {
            this.message = `Merci ${this.registrationForm.get("step1").value.firstname} de votre préinscription!`;
            this.submitted = false;
          }
          else {
            this.message =null;
            this.errorMessage = "l'email saisi est déjà utilisé. Veuillez en choisir un autre."
          }
          this.showSpinner = false;
        },
        error: error => {
          this.hasError = true;
          this.showSpinner = false;
          this.message =null; 
          this.errorMessage = "L'email saisi est déjà utilisé. Veuillez en choisir un autre."
        },
        complete: () => console.log('DONE!')
      });

  }


}
